// import { assign } from 'lodash';
// import { RelatorioTuboPreferencia } from '../models/tudo.model.ts';
import { DatePipe } from '@angular/common';

export class CastModelUtils {

    public static ClonarObjetoComPropriedadesIguais(source: any, destination: any): any {
        Object.keys(source).forEach((key) => {
            try {
                const tempKey = key.substring(0, 1).toLowerCase() + key.substring(1);
                if (tempKey in destination) {
                    destination[tempKey] = source[key];
                }
            } catch (err) {
                //ignore
            }
        });

        return destination;
    }

    // public static convertArrayToCSV(dataArray, headers) {
    //     const delimiter = ';'; // Use ponto e vírgula como delimitador

    //     if (!headers || headers.trim() === '') {
    //         throw new Error('Headers must be provided');
    //     }

    //     const headerKeys = headers.split(delimiter);

    //     // Filtra as linhas do dataArray para incluir apenas as chaves especificadas em headers
    //     const rows = dataArray.map(row => {
    //         return headerKeys.map(key => {
    //             // Retorna o valor da chave se existir, caso contrário retorna uma string vazia
    //             return row.hasOwnProperty(key) ? row[key] : '';
    //         }).join(delimiter);
    //     });

    //     // Junte os cabeçalhos e as linhas em uma string CSV
    //     const csvContent = [headers, ...rows].join('\n');

    //     // Adicione o BOM ao início do CSV
    //     const bom = '\uFEFF';
    //     return bom + csvContent;
    // }

    // public static formatDateTime(value: any, datePipe: DatePipe): string {
    //     if (!value) return '';
    //     let formattedDate = datePipe.transform(value, 'dd/MM/yyyy HH:mm:ss');
    //     if (formattedDate && formattedDate.endsWith('00:00:00')) {
    //         formattedDate = formattedDate.replace(' 00:00:00', '');
    //     }
    //     return formattedDate;
    // }

    // public static convertArrayToCSVTubo(dataArray, headers: string, headersDefinitions: RelatorioTuboPreferencia[], datePipe: DatePipe) {
    //     const delimiter = ';'; // Use ponto e vírgula como delimitador

    //     if (!headers || headers.trim() === '') {
    //         throw new Error('Headers must be provided');
    //     }

    //     const headerKeys = headers.split(delimiter);

    //     // Filtra as linhas do dataArray para incluir apenas as chaves especificadas em headers
    //     const rows = dataArray.map(row => {
    //         return headerKeys.map(key => {
    //             var header = headersDefinitions.find(x => x.nomeCampo === key);

    //             switch (header.formatacao) {
    //                 case 'DateTime':
    //                     return row.hasOwnProperty(key) ? this.formatDateTime(row[key], datePipe) : '';
    //                 default:
    //                     return row.hasOwnProperty(key) ? row[key] : '';
    //             }


    //             // Retorna o valor da chave se existir, caso contrário retorna uma string vazia

    //         }).join(delimiter);
    //     });

    //     // Junte os cabeçalhos e as linhas em uma string CSV
    //     return [headers, ...rows].join('\n');
    // }


    // public static downloadCSV(csvData, filename = 'data.csv') {
    //     // Crie um blob com os dados CSV
    //     const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    //     // Crie um link para download
    //     const link = document.createElement('a');
    //     if (link.download !== undefined) {
    //         // Define o URL do blob no link
    //         const url = URL.createObjectURL(blob);
    //         link.setAttribute('href', url);
    //         // Define o nome do arquivo
    //         link.setAttribute('download', filename);
    //         link.style.visibility = 'hidden';
    //         // Adiciona o link ao documento e clica nele
    //         document.body.appendChild(link);
    //         link.click();
    //         // Remove o link do documento
    //         document.body.removeChild(link);
    //     }
    // }
}
